import { ResourceSourceInput } from '@fullcalendar/resource';

export const DEPARTMENT_LIST: ResourceSourceInput = [
  { id: '0', title: 'Amen speech therapy' },
  { id: '1', title: 'General checkup' },
  { id: '2', title: 'Outpatients care' },
  { id: '3', title: 'Surgery' },
  { id: '4', title: 'Staff training' },
  { id: '5', title: 'Client support' },
  { id: '6', title: 'Project management' },
  { id: '7', title: 'Administration' },
  { id: '8', title: 'Other' },
];
